import React from "react";
import { useSelector, useDispatch } from "react-redux";
import classnames from "classnames";

import styles from "./high-frequency-word.module.css";
import * as highFrequencyWordActions from "../../redux/actions/highFrequencyWord";
import { srcPath } from "../../util/Path";
import { State } from "../../redux/store";
import WordCard from "./WordCard";
import { useAudio } from "../../hooks/CustomHooks";

interface Props {
  page: number;
  addImgLoaded: Function;
}

const IntroBoard = (props: Props) => {
  const { page, addImgLoaded } = props;
  return (
    <div className={styles.introBoard}>
      <div className={styles.introBoardWrapper}>
        <img
          className={styles.introBoardBg}
          src={srcPath("high-frequency-word/intro_board.png")}
          alt=""
          onLoad={() => addImgLoaded()}
        />
        <div className={styles.introBoardContainer}>
          {page === 1 && <TruckSelection addImgLoaded={addImgLoaded} />}
          {page === 2 && <PlaceSelection />}
          {page === 3 && <Instruction />}
        </div>
      </div>
    </div>
  );
};

const TruckSelection = (props) => {
  const { addImgLoaded } = props;
  const dispatch = useDispatch();
  const { truckType, truck, truckOptions } = useSelector(
    (state: State) => state.highFrequencyWord
  );

  const current = truckOptions.find((t) => t.truckType === truckType);

  return (
    <>
      <div className={styles.introBoardTitle}>
        Choose your truck and the colour.
      </div>
      <div className={styles.broadContainer}>
        <div className={styles.truckSelection}>
          <img
            className={classnames("btn", "main-btn")}
            src={srcPath("high-frequency-word/arrow_left.png")}
            onClick={() =>
              dispatch(highFrequencyWordActions.selectTruckType(false))
            }
            alt=""
            onLoad={() => addImgLoaded()}
          />
          {truck && (
            <img
              className={styles.truckSelectionTruck}
              src={srcPath(
                `high-frequency-word/trucks/NET_Game1_track_${truck}.png`
              )}
              alt=""
              onLoad={() => addImgLoaded()}
            />
          )}
          <img
            className={classnames("btn", "main-btn")}
            src={srcPath("high-frequency-word/arrow_right.png")}
            alt=""
            onClick={() =>
              dispatch(highFrequencyWordActions.selectTruckType(true))
            }
            onLoad={() => addImgLoaded()}
          />
        </div>
        <div className={styles.truckColorSelection}>
          {current &&
            current.trucks.map((t) => (
              <div
                key={t}
                className={classnames("btn", "main-btn")}
                onClick={() =>
                  dispatch(highFrequencyWordActions.selectTruck(t))
                }
              >
                <img
                  src={srcPath(
                    `high-frequency-word/trucks/NET_Game1_track_${t}_color.png`
                  )}
                  alt=""
                />
                {t === truck && (
                  <img
                    className={styles.truckColorSelectionTick}
                    src={srcPath(`high-frequency-word/tick.png`)}
                    alt=""
                  />
                )}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

const PlaceSelection = () => {
  const dispatch = useDispatch();
  const { placeOptions, place } = useSelector(
    (state: State) => state.highFrequencyWord
  );

  return (
    <>
      <div className={styles.introBoardTitle}>Pick your route.</div>
      <div className={styles.broadContainer} style={{ height: "510px" }}>
        <div className={styles.placeSelection}>
          {placeOptions.map((p) => (
            <div
              key={p}
              className={styles.placeSelectionBox}
              onClick={() => dispatch(highFrequencyWordActions.selectPlace(p))}
            >
              <img
                src={srcPath(`high-frequency-word/bg/icon_${p}.png`)}
                alt=""
              />
              {p === place && (
                <img
                  className={styles.placeSelectionTick}
                  src={srcPath(`high-frequency-word/tick.png`)}
                  alt=""
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const Instruction = () => {
  const playSampleAudio = useAudio(
    `high-frequency-word/audios/P1/Stage 1/P1 HFW List_Stage 1_this.wav`
  );

  return (
    <>
      <div className={styles.instructionBroadContainer}>
        <div className={styles.instructionContainer}>
          <div className={styles.instructionText}>
            Click to listen to the word.
          </div>
          <img
            className={classnames("btn", "main-btn")}
            src={srcPath("shared/speaker.png")}
            alt=""
            onClick={playSampleAudio}
          />
        </div>
        <div className={styles.instructionContainer}>
          <div className={styles.instructionText}>
            Drag the correct word onto the truck.
          </div>
          <WordCard word="this" canDrag={false} />
        </div>
      </div>
    </>
  );
};

export default IntroBoard;
